// extracted by mini-css-extract-plugin
export var accentColor = "var(--color-accent)";
export var categoryBorderColor = "var(--color-border)";
export var disableRipple = "true";
export var fontFamily = "var(--font-family)";
export var mainColor = "#d7000f";
export var mainContrast = "#fff";
export var panelBorderColor = "var(--color-border)";
export var secondaryColor = "#00a0e9";
export var secondaryContrast = "rgba(0,0,0,.87)";